import { jsx as _jsx } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const Share = (props) => {
    const iconProps = useIconProps(props);
    const strokeWidth = useStrokeWidth(iconProps.width);
    return (_jsx("svg", Object.assign({}, iconProps, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M30.112 14.8348L19.295 4.90857V10.5807C8.47803 11.9987 3.84218 19.0888 2.29689 26.179C6.1601 21.2159 11.5686 18.947 19.295 18.947V24.7609L30.112 14.8348Z", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinejoin: "round" }) })));
};
export default Share;
